import { useEffect, useState } from 'react';

type VideoQuality = 'low' | 'eco' | 'good';

interface NetworkInformation extends EventTarget {
    effectiveType: string;
    downlink: number;
    addEventListener(type: 'change', listener: () => void): void;
    removeEventListener(type: 'change', listener: () => void): void;
}

const detectQuality = (connection: NetworkInformation): VideoQuality => {
    const { effectiveType, downlink } = connection;

    if (effectiveType === '4g' && downlink > 5) return 'good';
    if (effectiveType === '4g' || downlink > 1.5) return 'eco';

    return 'low';
};

const getInitialQuality = (): VideoQuality => {
    if (typeof navigator === 'undefined') return 'good';
    const conn = (navigator as unknown as { connection?: NetworkInformation }).connection;
    if (!conn) return 'good';
    return detectQuality(conn);
};

const useNetworkVideoQuality = (): VideoQuality => {
    const [quality, setQuality] = useState<VideoQuality>(getInitialQuality);

    useEffect(() => {
        const connection = (navigator as unknown as { connection?: NetworkInformation }).connection;
        if (!connection) return undefined;

        const update = () => setQuality(detectQuality(connection));
        update();

        connection.addEventListener('change', update);

        return () => connection.removeEventListener('change', update);
    }, []);

    return quality;
};

export default useNetworkVideoQuality;
